import { apiProxyRequest as request } from "Api/apiProxyRequest";

export type GrantProjectTeamAccessPayload = Array<{ team_id: string }>;

export const grantProjectTeamAccess = (
  projectId: string,
  teams: GrantProjectTeamAccessPayload
) => request(`/projects/${projectId}/team-access`, "POST", teams);
